<script lang="ts">
	import Banner from './Banner.svelte';
	import type { PointsInfoBannerContent } from '../../domain/points-info-banner/PointsInfoBannerContent.ts';
	import { PointsInfoBannerType } from '../../domain/points-info-banner/PointsInfoBannerType.ts';

	let { content, type, enableSignupSheetMigration }: { content: PointsInfoBannerContent, type: PointsInfoBannerType, enableSignupSheetMigration: boolean }
		= $props();
</script>


<Banner pointsInfoBannerContent={content}
	pointsInfoBannerType={type}
	enableSignupSheetMigration={enableSignupSheetMigration}
/>
